export const formatNumber = (value) => {
  if (value === null || value === undefined) return "0";
  const num = parseFloat(value);
  if (isNaN(num)) return "0";
  return Math.round(num).toString();
};

export const formatGermanDate = (dateString) => {
  if (!dateString) return "-";
  
  try {
    if (dateString.includes('.')) {
      return dateString;
    }
    
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;
    
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    
    return `${day}.${month}.${year}`;
  } catch {
    return dateString;
  }
};

  export const formatDateTime = (dateString, locale = 'de-DE') => { 
    if (!dateString) return '-';
  
    const date = new Date(dateString);
    
    // التحقق من صحة التاريخ
    if (isNaN(date.getTime())) return '-';
    
    return new Intl.DateTimeFormat(locale, {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    }).format(date);
  };

  export const formatDate = (dateString, locale = 'de-DE') => {
    if (!dateString) return '-';
    
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '-';
    
    return new Intl.DateTimeFormat(locale, {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    }).format(date);
  };

  export const formatTime = (dateString, locale = 'de-DE') => {
    if (!dateString) return '-';
    
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '-';
    
    return new Intl.DateTimeFormat(locale, {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    }).format(date);
  };